export enum TagStatusLabel {
	Open = 'Em aberto',
	Sold = 'Vendido',
	Closed = 'Encerrado',
}
